import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ICON_MAP } from './iconRegistry.js';

// To add an icon: pick it on https://lucide.dev/icons and add the mapping in ./iconRegistry.js
function Icon({ icon = '', size = null, spin = null, className = null, ...props }) {
    const Component = icon && ICON_MAP[icon.toLowerCase()];

    if(!Component) {
        return <span {...props}>{process.env.NODE_ENV === 'development' && icon ? `ICON ${icon}` : ''}</span>;
    }

    return (
        <Component
            aria-hidden="true"
            focusable="false"
            className={classnames(className, 'icon', `icon-${size || '1x'}`, spin && 'icon-spin')}
            {...props}
        />
    );
}

Icon.propTypes = {
	icon: PropTypes.string,
	size: PropTypes.string,
	spin: PropTypes.bool,
	className: PropTypes.string,
};

export default memo(Icon);
